import { ENDPOINT_PATH_ACTIVITY_MASTERY } from '../../../helpers/constants';
import ActivityMasteryDataConverter from '../../../helpers/export-data-converter/activity-mastery-data-converter';
import {
    EXPORT_RESOURCE_METHODS,
    REPORT_LEVEL_ALL_YEARS,
    REPORT_LEVEL_ALL_CLASSES,
    REPORT_LEVEL_SINGLE_CLASS,
    REPORT_LEVEL_GROUP,
    REPORT_LEVEL_STUDENT,
    REPORT_LEVEL_YEAR_GROUP_TEACHER,
    FILE_FORMAT
} from './export-report-actions';
import activeFiltersSelectors from '../../report-filters/redux/active-filters/active-filters-selectors';

/**
 * Calculates the export parameters needed for the current activity mastery report
 */
export default function exportActivityMasteryReport(getState, reportLevel) {
    const state = getState();
    const {
        activityMasteryAllClasses,
        activityMasterySingleClass,
        activityMasteryStudent
    } = state;
    const selectedDate = activeFiltersSelectors.selectDate(state);

    const resourcesMethod = EXPORT_RESOURCE_METHODS[reportLevel];
    const params = {
        reportType: ENDPOINT_PATH_ACTIVITY_MASTERY,
        fileFormat: FILE_FORMAT.PDF
    };
    let data;

    switch (reportLevel) {
        case REPORT_LEVEL_ALL_YEARS:
        case REPORT_LEVEL_ALL_CLASSES:
        case REPORT_LEVEL_YEAR_GROUP_TEACHER: {
            data = ActivityMasteryDataConverter.convertAllClasses(
                activityMasteryAllClasses,
                selectedDate,
                activeFiltersSelectors.selectExportReportHeading(state),
                reportLevel === REPORT_LEVEL_ALL_YEARS
            );

            if (reportLevel === REPORT_LEVEL_YEAR_GROUP_TEACHER) {
                params.yearGroupId = activeFiltersSelectors.selectYearGroupIdForApi(
                    state
                );
                params.teacherId = activeFiltersSelectors.selectTeacherIdForApi(
                    state
                );
            }
            break;
        }

        case REPORT_LEVEL_SINGLE_CLASS:
        case REPORT_LEVEL_GROUP:
            data = ActivityMasteryDataConverter.convertSingleClass(
                activityMasterySingleClass,
                selectedDate,
                reportLevel === REPORT_LEVEL_GROUP
                    ? activeFiltersSelectors.selectGroupId(state)
                    : null
            );
            params.classroomId = activeFiltersSelectors.selectClassId(state);
            break;

        case REPORT_LEVEL_STUDENT: {
            const selectedStudent = activeFiltersSelectors.selectStudent(state);
            data = ActivityMasteryDataConverter.convertStudent(
                activityMasteryStudent,
                selectedDate,
                selectedStudent
            );
            params.classroomId = activeFiltersSelectors.selectClassId(state);
            params.userProfileId = selectedStudent.id;
            break;
        }

        default:
    }

    return { data, resourcesMethod, params };
}



// WEBPACK FOOTER //
// ./components/sub-heading/export-report/export-activity-mastery-report.js